import { Timezones } from "@epcnetwork/core-ui-kit";

export const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone as Timezones;
